import { create } from "zustand";
import { getData } from "../utils/formHelpers";
import { IsotoposInstalacionType } from "../../app/types/genericTables.types";

type UseIsotoposInstalacionType = {
  isotoposInstalacionList: IsotoposInstalacionType[];
  get: (
    id: IsotoposInstalacionType["id"]
  ) => IsotoposInstalacionType | undefined;
  query: string;
  setQuery: (query: string) => void;
  fetchAll: () => void;
  loading: boolean;
};

export const useIsotoposInstalacion = create<UseIsotoposInstalacionType>(
  (set, get) => ({
    loading: false,
    isotoposInstalacionList: [],
    query: "",
    setQuery: (query) => set({ query }),
    get: (id) =>
      get().isotoposInstalacionList.find(
        (isotoposInstalacion) => isotoposInstalacion.id === id
      ),
    fetchAll: async () => {
      set({ loading: true });
      try {
        const endpoint = "/generic/IsotoposInstalacion";
        const { data: response } = await getData(endpoint);
        set(() => ({
          isotoposInstalacionList: response,
          loading: false,
        }));
      } catch (error) {
        console.error("Error fetching isotoposInstalacionList:", error);
        set({ loading: false });
      }
    },
  })
);
